import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {
  SkillSpecializationCreateRequest,
  SkillSpecializationResponse,
  SkillSpecializationListItem,
  CuratorAssignRequest,
  TheoryLevelRequest,
  PracticeLevelRequest,
} from '../models/skill-learning.model';
import { SKILL_SPECIALIZATIONS_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillSpecializationApiService {

  private readonly jsonHeaders = new Headers({ 'Content-Type': 'application/json' });
  private readonly jsonOptions = new RequestOptions({ headers: this.jsonHeaders });

  constructor(private http: Http) {}

  fetchAllSpecializations(): Observable<SkillSpecializationListItem[]> {
    return this.http
      .get(SKILL_SPECIALIZATIONS_API.BASE)
      .map(response => response.json() as SkillSpecializationListItem[]);
  }

  fetchAvailableSpecializations(): Observable<SkillSpecializationListItem[]> {
    return this.http
      .get(SKILL_SPECIALIZATIONS_API.AVAILABLE)
      .map(response => response.json() as SkillSpecializationListItem[]);
  }

  fetchSpecializationById(id: string): Observable<SkillSpecializationResponse> {
    return this.http
      .get(SKILL_SPECIALIZATIONS_API.BY_ID(id))
      .map(response => response.json() as SkillSpecializationResponse);
  }

  fetchSpecializationsByGroup(groupId: string): Observable<SkillSpecializationListItem[]> {
    return this.http
      .get(SKILL_SPECIALIZATIONS_API.BY_GROUP(groupId))
      .map(response => response.json() as SkillSpecializationListItem[]);
  }

  fetchMyCuratedSpecializations(): Observable<SkillSpecializationListItem[]> {
    return this.http
      .get(SKILL_SPECIALIZATIONS_API.MY_CURATED)
      .map(response => response.json() as SkillSpecializationListItem[]);
  }

  createSpecialization(request: SkillSpecializationCreateRequest): Observable<SkillSpecializationResponse> {
    return this.http
      .post(SKILL_SPECIALIZATIONS_API.BASE, JSON.stringify(request), this.jsonOptions)
      .map(response => response.json() as SkillSpecializationResponse);
  }

  updateSpecialization(id: string, request: SkillSpecializationCreateRequest): Observable<SkillSpecializationResponse> {
    return this.http
      .put(SKILL_SPECIALIZATIONS_API.BY_ID(id), JSON.stringify(request), this.jsonOptions)
      .map(response => response.json() as SkillSpecializationResponse);
  }

  deactivateSpecialization(id: string): Observable<void> {
    return this.http
      .delete(SKILL_SPECIALIZATIONS_API.BY_ID(id))
      .map(() => undefined);
  }

  assignCurators(id: string, request: CuratorAssignRequest): Observable<void> {
    return this.http
      .post(SKILL_SPECIALIZATIONS_API.CURATORS(id), JSON.stringify(request), this.jsonOptions)
      .map(() => undefined);
  }

  removeCurator(id: string, curatorId: string): Observable<void> {
    return this.http
      .delete(SKILL_SPECIALIZATIONS_API.CURATOR_BY_ID(id, curatorId))
      .map(() => undefined);
  }

  updateTheoryLevel(id: string, request: TheoryLevelRequest): Observable<void> {
    return this.http
      .put(SKILL_SPECIALIZATIONS_API.THEORY_LEVEL(id), JSON.stringify(request), this.jsonOptions)
      .map(() => undefined);
  }

  updatePracticeLevel2(id: string, request: PracticeLevelRequest): Observable<void> {
    return this.http
      .put(SKILL_SPECIALIZATIONS_API.PRACTICE_LEVEL_2(id), JSON.stringify(request), this.jsonOptions)
      .map(() => undefined);
  }

  updatePracticeLevel3(id: string, request: PracticeLevelRequest): Observable<void> {
    return this.http
      .put(SKILL_SPECIALIZATIONS_API.PRACTICE_LEVEL_3(id), JSON.stringify(request), this.jsonOptions)
      .map(() => undefined);
  }

  uploadLevelDocument(id: string, level: number, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http
      .post(SKILL_SPECIALIZATIONS_API.LEVEL_DOCUMENT(id, level), formData)
      .map(response => response.text());
  }

  buildLevelDocumentDownloadUrl(id: string, level: number): string {
    return SKILL_SPECIALIZATIONS_API.LEVEL_DOCUMENT(id, level);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-specialization-api.service.ts